export default __webpack_public_path__ + "static/media/coresanscr55it-webfont.1dafa301.woff";